import Config from '@/Config';
import Resources from '@/Resources';
import { projectListItemTypes, projectPhaseSearchType } from '@/Models';
import { addRef } from '@/Utils/UrlUtility';

function getProjectListItemTypeResource(projectListItemType) {
    return Resources.Homepage[projectListItemTypes[projectListItemType].displayName];
}

function buildSearchUrl(phaseTypes) {
    const phaseTypesArray = Array.isArray(phaseTypes) ? phaseTypes : [phaseTypes];
    const phaseNames = phaseTypesArray.map(type => projectPhaseSearchType[type].name);
    return `${Config.navigation.searchUrl}?ProjectPhaseSearchTypes=${phaseNames.join(',')}`;
}

export function useExploreNavigation() {
    const navigationItems = [
        {
            name: getProjectListItemTypeResource(projectListItemTypes.upcoming),
            url: addRef('mobile-navigation', 'explore-upcoming', buildSearchUrl(
                projectPhaseSearchType.upcoming,
            ), 1),
        },
        {
            name: getProjectListItemTypeResource(projectListItemTypes.crowdfunding),
            url: addRef('mobile-navigation', 'explore-crowdfunding', buildSearchUrl(
                projectPhaseSearchType.crowdfunding,
            ), 2),
        },
        {
            name: getProjectListItemTypeResource(projectListItemTypes.latePledge),
            url: addRef('mobile-navigation', 'explore-latePledge', buildSearchUrl(
                projectPhaseSearchType.latePledge,
            ), 3),
        },
        {
            name: getProjectListItemTypeResource(projectListItemTypes.storesAndPreorders),
            url: addRef('mobile-navigation', 'explore-preorder', buildSearchUrl([
                projectPhaseSearchType.store,
                projectPhaseSearchType.preorder,
            ]), 4),
        }];

    return {
        navigationItems,
    };
}